import { render, staticRenderFns } from "./Accueil.vue?vue&type=template&id=689679b3&"
import script from "./Accueil.vue?vue&type=script&lang=js&"
export * from "./Accueil.vue?vue&type=script&lang=js&"
import style0 from "./Accueil.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports